import { Box, Button, Card, CardHeader, Grid, Divider, Typography, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import useLayoutContext from "src/hooks/useAuthLayout";
import axios from 'axios'
import Label from "src/components/Label";
import TabsGeneral from "src/components/Tabs";
import confirmSweetAlert from "src/utils/confirm";

export default function Index() {
    const { drawerOpen } = useLayoutContext()
    const [turno, setTurno] = useState(null)
    const [sitedVigente, setSitedVigente] = useState(null)
    const [tabs, setTabs] = useState([{ value: '01', label: 'Sited Vigente', active: true }, { value: '02', label: 'Cambio de Sited', active: false }])
    const [text, setText] = useState({

        autorizacion: {
            value: '',
            error: false,
            errorText: ''
        }
    })

    const handleChange = (event) => {
        const { name, value } = event.target;

        setText((prevState) => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: value,
                error: false, // Resetear el error al cambiar el valor
                errorText: '' // Resetear el mensaje de error
            }
        }));
    };

    const handleBlur = (event) => {
        const { name, value } = event.target;

        if (value.trim() === '') {
            setText((prevState) => ({
                ...prevState,
                [name]: {
                    ...prevState[name],
                    error: true,
                    errorText: 'Este campo es requerido'
                }
            }));
        }
    };
    useEffect(() => {
        const handleBuscar = async (id) => {
            try {
                const response = await axios.get(`https://apis.vesaliohce.com.pe/clinica-new/getRetornarALtaSistcomp/${id}`)

                if (response.status === 200) {
                    console.log(response.data)
                    if (response.data.estado) {
                        if (response.data.turno !== null) {
                            setTurno(response.data.turno)
                        }
                        if (response.data.siteds.length > 0) {
                            setSitedVigente(response.data.siteds[0])

                        }
                    }

                }
            } catch (e) {
                console.log(e)
            }
        }
        handleBuscar(drawerOpen.item.medicion_id)
        console.log(drawerOpen.item)
    }, [drawerOpen])

    const validarCampos = () => {
        let hayErrores = false;

        Object.keys(text).forEach((key) => {
            if (text[key].value === '') {
                setText((prevState) => ({
                    ...prevState,
                    [key]: {
                        ...prevState[key],
                        error: true,
                        errorText: 'Este campo es requerido'
                    }
                }));
                hayErrores = true;
            }
        });

        return hayErrores;
    };
    const handleGuardar = async () => {

        const hayErrores = validarCampos();
        if (hayErrores) {
            confirmSweetAlert('Error', 'No debe haber campos Vacios', 'error', false)
            return;
        }
        const response = await axios.post(`https://apis.vesaliohce.com.pe/clinica-new/cambiarSitedEmergencia`, {
            autorizacion: text.autorizacion.value,
            atencion:  turno.estado_turno_id === 1 ? sitedVigente.AtencionNumero  :  turno.autorizacion
        })

        if (response.status === 200) {
            confirmSweetAlert('Correcto', 'Cambio el SITEDs correctamente', 'error', false)
        } else {
            confirmSweetAlert('Error', 'Ocurrio un error al realizar el campo del SITED', 'error', false)
        }

    }


    const isActive = tabs.find(x => x.active)

    return (
        <Box sx={{ p: 2 }}>

            <Grid container
                direction="row"
                justifyContent="center"
                alignItems="stretch"
                spacing={2}>
                <Grid item xs={12} lg={12}>
                    <Typography variant="h4">{drawerOpen.item.paciente}</Typography>
                </Grid>
                {
                    turno !== null && <Grid item xs={12} lg={12}>
                        <Card sx={{ p: 2 }}>
                            <CardHeader title="Datos de la consulta" />
                            <Divider />
                            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                                <Typography variant="h5" sx={{ mb: 1 }}><b>Fecha</b></Typography>
                                <Typography variant="h5" sx={{ mb: 1, color: "blue" }}><b>{turno.fecha === null ? '-' : turno.fecha.split('T')[0]}</b></Typography>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                                <Typography variant="h5" sx={{ mb: 1 }}><b>Hora</b></Typography>
                                <Typography variant="h5" sx={{ mb: 1, color: "blue" }}><b>{turno.hora === null ? '-' : turno.hora}</b></Typography>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                                <Typography variant="h5" sx={{ mb: 1 }}><b>Estado</b></Typography>
                                <Label color={turno.estado_turno_id === 5 ? 'success' : 'primary'}>
                                    {turno.estado_turno_id === 5 ? 'Realizado' : 'Pendiente'}
                                </Label>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                                <Typography variant="h5" sx={{ mb: 1 }}><b>Autorizacion Asignada</b></Typography>
                                <Typography variant="h3" sx={{ mb: 1, color: "red" }}><b>{turno.autorizacion}</b></Typography>
                            </Box>
                        </Card>
                    </Grid>
                }
                <Box sx={{ p: 2, mt: 2, mb: -5 }}>
                    <TabsGeneral setTabs={setTabs} tabs={tabs} />
                </Box>


                {
                    isActive.value === '01' && <>

                        {
                            sitedVigente !== null && <Grid item xs={12} lg={12}>
                                <Card sx={{ p: 2 }}>
                                    <CardHeader title="SITEDS Vigente" />
                                    <Divider />
                                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                                        <Typography variant="h5" sx={{ mb: 1 }}><b>Especialidad</b></Typography>
                                        <Typography variant="h5" sx={{ mb: 1, color: "blue" }}><b>{sitedVigente.EspecialidadNombre === null ? '-' : sitedVigente.EspecialidadNombre}</b></Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                                        <Typography variant="h5" sx={{ mb: 1 }}><b>Financiadora</b></Typography>
                                        <Typography variant="h5" sx={{ mb: 1, color: "blue" }}><b>{sitedVigente.FinanciadoraNombre === null ? '-' : sitedVigente.FinanciadoraNombre}</b></Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                                        <Typography variant="h5" sx={{ mb: 1 }}><b>CPM</b></Typography>
                                        <Label color={sitedVigente.EsCPM === 'SI' ? 'success' : 'error'}>
                                            {sitedVigente.EsCPM}
                                        </Label>
                                    </Box>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                                        <Typography variant="h5" sx={{ mb: 1 }}><b>Autorizacion Asignada</b></Typography>
                                        <Typography variant="h3" sx={{ mb: 1, color: "red" }}><b>{sitedVigente.AtencionNumero}</b></Typography>
                                    </Box>
                                </Card>
                            </Grid>
                        }
                    </>
                }
                {
                    isActive.value === '02' && <Grid item xs={12} lg={12}>
                        <Card sx={{ p: 2, display: "flex", gap: 2 }}>

                            <TextField
                                fullWidth
                                sx={{ mt: 1 }}
                                value={text.autorizacion.value}
                                name={"autorizacion"}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                label="Numero de Autorizacion SITED"
                                error={text.autorizacion.error}
                                helperText={text.autorizacion.errorText}
                            />

                        </Card>
                    </Grid>
                }

                <Grid item xs={12} lg={12}>
                    <Button
                        onClick={handleGuardar}
                        variant='contained'
                        fullWidth >Solicitar</Button>
                </Grid>
            </Grid>
        </Box>
    )
}
